import {
    Box,
    Grid,
    Flex,
    GridItem,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
} from '@chakra-ui/react';
import type { SubscriptionInfo } from './TableSection';
import { StyledBox } from './styles';
import { useRef } from 'react';

interface Props {
    valuesName: { [key: string]: string };
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    isOpenAll?: Boolean;
}

export const TableSectionMobile = ({
    tableSection,
    mainCategories,
    valuesName,
    isOpenAll,
}: Props) => {
    const allowMultiple = isOpenAll ? true : undefined;
    const TableSectionContent = (section: SubscriptionInfo) => {
        return (
            <Box mt={4} mb={1}>
                <Text textAlign={'center'} fontSize={'sm'} mb={3}>
                    {section.name}
                </Text>
                {Object.keys(section.values).map((keyName, i, array) => (
                    <Flex
                        justifyContent={'space-around'}
                        alignItems={'center'}
                        borderBottom={i !== array.length - 1 ? '1px solid #E3E3E3' : 'none'}
                    >
                        <Text w={'75%'} color={'#1aac7a'} fontSize={'md'} fontWeight={'normal'}>
                            {keyName}
                        </Text>
                        <StyledBox
                            p={4}
                            h="100%"
                            display={'flex'}
                            color={'#171717'}
                            fontSize={'xs'}
                            fontWeight={'normal'}
                            lineHeight={'150%'}
                            // alignItems={{ base: 'flex-start', lg: 'center' }}
                            // justifyContent={{ base: 'flex-start', lg: 'center' }}

                            // dangerouslySetInnerHTML={{ __html: section.values[keyName] }}
                        >
                            {section.values[keyName]}
                        </StyledBox>
                    </Flex>
                ))}
            </Box>
        );
    };
    const accordionItemRefs = useRef([]);

    const handleAccordionChange = (index: number) => {
        const currentAccordionItem = accordionItemRefs.current[index];
        console.log('handleAccordionChange', currentAccordionItem);

        if (currentAccordionItem) {
            setTimeout(() => {
                //@ts-expect-error
                const offsetTop = currentAccordionItem.offsetTop;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth',
                });
            }, 300);
        }
    };

    return (
        <Box>
            <Accordion allowToggle onChange={handleAccordionChange} allowMultiple={allowMultiple}>
                {Object.keys(mainCategories).map((mainCat, i) => (
                    //@ts-expect-error
                    <AccordionItem ref={el => (accordionItemRefs.current[i] = el)}>
                        <AccordionButton
                            padding={'10px 15px'}
                            background={'#eeeeee'}
                            color={'#171717'}
                            fontSize={'18px'}
                            fontWeight={'600'}
                            justifyContent={'space-between'}
                        >
                            {mainCategories[mainCat]}
                            <AccordionIcon />
                        </AccordionButton>
                        {tableSection.map(section => {
                            if (section.category === mainCategories[mainCat]) {
                                return (
                                    <AccordionPanel>{TableSectionContent(section)}</AccordionPanel>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};
